<template>
  <div>
    <div class="d-flex align-center mb-5 ml-11 mt-n5" style="gap: 16px;">
      <img
        v-if="serviceProviderLogoUrl"
        :src="serviceProviderLogoUrl"
        :alt="serviceProviderName"
        style="max-height: 48px; max-width: 120px; object-fit: contain;"
      />
      <h3 class="grey--text display-1 mb-0">
        {{ serviceProviderName }}
      </h3>
      <v-progress-circular v-if="isServiceProviderLogoUploading" indeterminate color="primary" size="24" />
      <v-btn
        v-else
        icon
        small
        @click="$refs.logoInput.click()"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <input
        ref="logoInput"
        type="file"
        accept="image/png, image/jpeg, image/jpg"
        style="display: none;"
        @change="handleLogoUpload"
      />
    </div>

    <v-row>
      <v-col cols="12" lg="2" md="3" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ documentLabel }}
        </h6>
        <p class="body-2">
          {{ serviceProviderDocument }}
        </p>
      </v-col>
      <v-col cols="12" lg="2" md="3" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ createdAt }}
        </h6>
        <p class="body-2">
          {{ serviceProviderCreatedAt }}
        </p>
      </v-col>
      <v-col cols="12" lg="2" md="3" sm="4">
        <h6 class="text-uppercase grey--text">
          {{ updatedAt }}
        </h6>
        <p class="body-2">
          {{ serviceProviderUpdatedAt }}
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { formatDocument } from '@/util/document'
import { catalogDate } from '../../../util/catalog'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ServiceProviderDetailsHeader',

  props: {
    serviceProvider: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['isServiceProviderLogoUploading']),

    serviceProviderName() {
      return this.serviceProvider.name
    },

    serviceProviderDocument() {
      return this.serviceProvider.document
        ? formatDocument(this.serviceProvider.document)
        : '---'
    },

    serviceProviderCreatedAt() {
      return this.serviceProvider.date_created
        ? catalogDate(this.serviceProvider.date_created)
        : '---'
    },

    serviceProviderUpdatedAt() {
      return this.serviceProvider.last_updated
        ? catalogDate(this.serviceProvider.last_updated)
        : '---'
    },

    serviceProviderLogoUrl() {
      return this.serviceProvider.logo?.external_url || null
    },
  },

  methods: {
    ...mapActions(['uploadServiceProviderLogo']),
    formatDocument,

    async handleLogoUpload(event) {
      const file = event.target.files[0]
      if (!file) return
      await this.uploadServiceProviderLogo({
        serviceProviderId: this.serviceProvider.id,
        file,
      })
      event.target.value = ''
    },
  },

  data() {
    return {
      documentLabel: this.$t('forms.document'),
      createdAt: this.$t('forms.createdAt'),
      updatedAt: this.$t('forms.updatedAt'),
    }
  }
}
</script>
